import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { CustomersServices } from '../../customers/services';
import { Globals } from '../../../globals';
import { ProvidersServices } from '../../providers/services';
import { TakeawayServices } from '../../takeaway/services';
import { OrdersCoServices } from '../../orders/services';
import { TPVServices } from '../../tpv/services';
import { InvoicesServices } from '../../invoices/services';
import { SearchReservationsServices } from '../../services/searchsReservation';

/**
 * Component que a traves de un array de Allergens muestra su icona
 *
 * Paso a crear:
 * Poder escoger el tamaño del icono
 */

@Component({
  selector: 'comp-searcher-rooms-tables',
  templateUrl: 'searcher-rooms-tables.html',
})
export class SearcherRoomsTablesPage {
  @Input() form;
  @Input() og;

  keyboard: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public customersServices: CustomersServices,
    public globals: Globals,
    public providersServices: ProvidersServices,
    public takeawayServices: TakeawayServices,
    public searchReservationsServices: SearchReservationsServices,
    public ordersCoServices: OrdersCoServices,
    public tpvServices: TPVServices,
    public invoicesService: InvoicesServices) {

  }

  async ngOnInit() {
    this.searchReservationsServices.og = this.og;
    await this.clear();
    this.searchReservationsServices.passObservableToArray();
  }

  selectTable(table) {
    //Guardamos el form en searchService
    this.searchReservationsServices.form = this.form;
    //Seleccionamos el cliente
    this.searchReservationsServices.selectTable(table);
  }

  clear() {
    //
    this.searchReservationsServices.selectedTableId = '';
    this.searchReservationsServices.tables_data = undefined;
    this.searchReservationsServices.tables_search = '';
    this.searchReservationsServices.show_list = false;
    this.searchReservationsServices.searchTable();
    //by type
    this.form.get('customer_table').setValue('');
  }

  showList() {
    this.searchReservationsServices.show_list = false;
    if (this.keyboard) {
      this.keyboard = false;
    } else {
      this.keyboard = true;
    }
  }

  async selectKeyboard() {
    //Guardamos el form en searchService
    this.searchReservationsServices.form = this.form;
    //Recuperamos el mesa
    var table = await this.takeawayServices.getTable(this.searchReservationsServices.selectedTableId);
    //Llenamos los inputs con los datos del cliente seleccionado
    this.searchReservationsServices.selectTable(table);
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/searcher-rooms-tables/searcher-rooms-tables.ts